import { Tooltip, Typography } from 'antd';
import type { CSSProperties, ReactNode } from 'react';

export interface TipTextProps {
  /** 单元格展示文本（空值显示 '-'）。 */
  text: ReactNode;
  /** 悬浮提示内容；缺省时与 text 相同（完整内容）。 */
  tip?: ReactNode;
  style?: CSSProperties;
}

/**
 * 列表截断单元格统一悬浮组件：
 * 用 antd Tooltip（渲染挂 body）替代浏览器原生 title 浮层，
 * 避免在 scroll={{ x }} 的横向滚动表格里原生浮层被裁切/定位到页面外、
 * 或鼠标换行后仍显示上一条的悬浮内容。
 * 配合列定义 `ellipsis: { showTitle: false }` 使用（showTitle:false 防原生浮层回退）。
 */
export function TipText({ text, tip, style }: TipTextProps) {
  return (
    <Tooltip title={tip ?? text} placement="topLeft">
      <Typography.Text ellipsis style={{ display: 'block', ...style }}>
        {text}
      </Typography.Text>
    </Tooltip>
  );
}

/**
 * 列 render 快捷方式：单行截断 + antd Tooltip 展示完整内容。
 * 用法：`ellipsis: { showTitle: false }, render: ellipsisCell('materialName')`
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ellipsisCell(field: string) {
  return (_: unknown, row: any) => {
    const value = row?.[field];
    return value == null || value === '' ? '-' : <TipText text={String(value)} />;
  };
}

export default TipText;
